import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IComponentOptions, IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _, {isNil} from "lodash";
import {OppgaveRessurs} from "felles/tjenester/ressurser/OppgaveRessurs";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {RedigerOppgaveDialog} from "../../modale/redigerOppgaveDialog/redigerOppgaveDialog";
import {KommentarerTjeneste} from "felles/tjenester/modulspesifikke/KommentarTjeneste";
import {ngSortable} from "../../../../../types/ngSrotable";
import {VisOppgaveDialog} from "../../modale/visOppgaveDialog/visOppgaveDialog";
import {EnumOversettelser} from "felles/tjenester/i18n/EnumOversettelser";
import {KommentarDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {kopierFraAjsTilNg2} from "felles-ng2/modell/ajsNg2ModellBroer";
import {Kontekst} from "felles/tjenester/Kontekst";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import Oppgavestatus = l.Oppgavestatus;

const css = require('./oppgaverKanban.scss');

//todo sørge for at wk-meny ikke kan trigges mens man drar oppgave
export function registrerOppgaverKanbanKomponent(angular: IModule) {
    angular
        .component('wmOppgaverKanban', oppgaverKanbanKomponentDef())
}

export function oppgaverKanbanKomponentDef(): IComponentOptions {
    return {
        bindings: {oppgaver: "<", oppdaterStatus: '&'},
        controller: OppgaverKanbanKontroller.forInjisering(),
        template: require('./oppgaverKanban.html')
    };
}

export class OppgaverKanbanKontroller implements IController {

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            OppgaveRessurs.regNavn,
            EnumOversettelser.regNavn,
            RedigerOppgaveDialog.regNavn,
            VisOppgaveDialog.regNavn,
            ModelloppdateringTjeneste.regNavn,
            ng2RegNavn.KommentarDatatjenesteForAjs,
            Kontekst.regNavn,
            OppgaverKanbanKontroller
        ]
    }

    constructor(private $scope: IScope,
                private oppgaveRessurs: OppgaveRessurs,
                private enumOversettelser:EnumOversettelser,
                private redigerOppgaveDialog: RedigerOppgaveDialog,
                private visOppgaveDialog: VisOppgaveDialog,
                private modelloppdatering: ModelloppdateringTjeneste,
                private kommentarDatatjeneste: KommentarDatatjenesteForAjs,
                private kontekst: Kontekst) {
        this.lyttTilNyOppgave();
        this.lyttTilOppgaveOppdatert();
        this.lyttTilOppgaveSlettet();
    }

    gruppert: Oppgavegruppe[];
    oppdaterStatus: (args: { spesifikasjon: { id: string, status: l.Oppgavestatus } }) => void;

    kolonnenavn(kolonne: OppgaveKolonner) {
        switch (kolonne) {
            /// tittel planlagte-kolonnen i oppgavekanban
            case OppgaveKolonner.planlagte:
                return this.enumOversettelser.oversettOppgaveStatus(Oppgavestatus.ikke_påbegynt);
            /// tittel aktive-kolonnen i oppgavekanban
            case OppgaveKolonner.aktive:
                return this.enumOversettelser.oversettOppgaveStatus(Oppgavestatus.påbegynt);
            /// tittel utførte-kolonnen i oppgavekanban
            case OppgaveKolonner.utfoerte:
                return this.enumOversettelser.oversettOppgaveStatus(Oppgavestatus.utført);
        }
    }

    vis(oppgave: l.OppgaveModell) {
        this.visOppgaveDialog.visVisOppgaveDialog(oppgave);
    }

    rediger(oppgave: l.OppgaveModell) {
        this.redigerOppgaveDialog.visRedigerOppgaveDialog(oppgave);
    }

    gruppefarge(gruppeId: string) {
        return this.kontekst.finnAutentiserteGruppe(gruppeId).farge;
    }

    antallKommentarer(oppgave: l.OppgaveModell) {
        return KommentarerTjeneste.antallKommentarerOgSvar(oppgave.kommentarer);
    }

    /** konfig for ng-sortable.
     * Merk: kan ikke bruke accept(..) for å hindre flytting til spesifikke kolonner fordi dersom element har vært dratt
     * over kolonne man kan flytt til og så videre til kolonne man ikke kan flytte til vil element bli flyttet
     * til siste kolonne elementet ble dratt over som man kan flytte til dersom man slipper elementet over
     * man ikke kan flyttet til, ønsket oppførsel hadde vært at element forble i kolonnene det opprinnelig var i */
    ngSortableKonfig(): ngSortable.DragControlListeners<l.OppgaveModell> {
        return {
            /** håndterer at element har blitt flyttet til annen kolonne */
            itemMoved: (e) => {
                //console.log("itemMoved", e)

                const flyttetOppgave = e.source.itemScope.modelValue;
                const fraGruppe: Oppgavegruppe = e.source.sortableScope['gruppe'];
                const tilGruppe: Oppgavegruppe = e.dest.sortableScope['gruppe'];
                this.oppgaveFlyttet(flyttetOppgave, fraGruppe, tilGruppe);
            },
            /** Forhindrer endring av rekkefølge.*/
            orderChanged: (e) => {
                //console.log("orderChanged")
                this.reverserFlytting(e);
            }
        };
    }

    $onChanges(changes: IOnChangesObject) {
        if (changes['oppgaver'] && changes['oppgaver'].currentValue)
            this.initGrupper(changes['oppgaver'].currentValue);
    }

    // hjelpemetoder

    private initGrupper(oppgaver: l.OppgaveModell[]) {
        this.gruppert = <any>_(oppgaver)
            .map(oppgave => ({oppgave: oppgave, kolonne: this.beregnKolonnne(oppgave)}))
            .groupBy(oppgaveOgKolonne => {
                return oppgaveOgKolonne.kolonne
            })
            .mapValues((oppgaveOgKolonne: { oppgave: l.OppgaveModell, kolonne: OppgaveKolonner }[]) =>
                ({kolonne: oppgaveOgKolonne[0].kolonne, oppgaver: _(oppgaveOgKolonne).map("oppgave").value()})
            )
            .defaultsDeep(this.standardKolonner())
            .values()
            .orderBy("sortering")
            .value();

        // sorter etter utførtdato, med de nyeste øverst. det samme som order by utførtdato desc
       const utfoertGruppe =  this.gruppert.find(gruppert => gruppert.kolonne === OppgaveKolonner.utfoerte);
       if (!isNil(utfoertGruppe)) {
           utfoertGruppe.oppgaver.sort((a, b) => b.utfoertDato.getTime() - a.utfoertDato.getTime());
       }
        //console.log("GRUPPERT", this.gruppert)
    }

    private standardKolonner() {
        const kolonner = {};
        kolonner[OppgaveKolonner.planlagte] = {kolonne: OppgaveKolonner.planlagte, sortering: 2, oppgaver: []};
        kolonner[OppgaveKolonner.aktive] = {kolonne: OppgaveKolonner.aktive, sortering: 3, oppgaver: []};
        kolonner[OppgaveKolonner.utfoerte] = {kolonne: OppgaveKolonner.utfoerte, sortering: 4, oppgaver: []};
        return kolonner;
    }

    private beregnKolonnne(oppgave: l.OppgaveModell): OppgaveKolonner {
        //populer KommentarerDatatjeneste (for at <kommentarer-teller> og <oppgave-kommentarer> skal ha tilgang til data)
        this.kommentarDatatjeneste.tjeneste().then(kommentarerDatatjeneste =>
            kommentarerDatatjeneste.erstattILokallager(kopierFraAjsTilNg2(oppgave.kommentarer), oppgave.id));

        switch (oppgave.status) {
            case l.Oppgavestatus.ikke_påbegynt:
                return OppgaveKolonner.planlagte;
            case l.Oppgavestatus.påbegynt:
                return OppgaveKolonner.aktive;
            case l.Oppgavestatus.utført:
                return OppgaveKolonner.utfoerte;
        }
    }

    /** Reverserer element flyttet via ng-sortable */
    private reverserFlytting(e: ngSortable.Event<l.OppgaveModell>) {
        e.dest.sortableScope.removeItem(e.dest.index);
        e.source.itemScope.sortableScope.insertItem(e.source.index, e.source.itemScope.modelValue);
    }

    private oppgaveFlyttet(oppgave: l.OppgaveModell, fra: Oppgavegruppe, til: Oppgavegruppe) {
        let spesifikasjon: l.OppgaveStatusSpesifikasjon;

        switch (til.kolonne) {
            case OppgaveKolonner.planlagte:
                if(oppgave.status != l.Oppgavestatus.ikke_påbegynt) {
                    spesifikasjon = {
                        id: oppgave.id,
                        status: l.Oppgavestatus.ikke_påbegynt
                    }
                }
                break;

            case OppgaveKolonner.aktive:
                if(oppgave.status != l.Oppgavestatus.påbegynt) {
                    spesifikasjon = {
                        id: oppgave.id,
                        status: l.Oppgavestatus.påbegynt
                    }
                }
                break;

            case OppgaveKolonner.utfoerte:
                if(oppgave.status != l.Oppgavestatus.utført) {
                    spesifikasjon = {
                        id: oppgave.id,
                        status: l.Oppgavestatus.utført,
                        utfoertDato: new Date()
                    }
                }
                break;
        }

        if(!_.isNil(spesifikasjon)) {
            this.oppgaveRessurs.settStatus(spesifikasjon);
        }
    }

    private finnOppgavensGruppe(oppgaveId: string): Oppgavegruppe {
        return _(this.gruppert).find(gruppe => _(gruppe.oppgaver).some({id: oppgaveId}))
    }

    //modelloppdateringslyttere

    private lyttTilNyOppgave() {
        this.modelloppdatering.vedNyOppgave(
            oppgaveOgMøte => true, //todo match ihht aktive filter
            this.$scope,
            oppgaveOgMøte => {
                this.oppgaveRessurs.hent(oppgaveOgMøte.oppgaveId).$promise.then(oppgave => {
                    _(this.gruppert).find({kolonne: this.beregnKolonnne(oppgave)}).oppgaver.push(oppgave);
                });
            });
    }

    private lyttTilOppgaveOppdatert() {
        this.modelloppdatering.vedOppdatertOppgave(
          oppgaveOgMøte => this.finnOppgavensGruppe(oppgaveOgMøte.oppgaveId) != null,
          this.$scope,
          oppgaveOgMøte => {
              const gruppe = this.finnOppgavensGruppe(oppgaveOgMøte.oppgaveId);
              this.oppgaveRessurs.hent(oppgaveOgMøte.oppgaveId).$promise.then(oppgave => {
                  const nyGruppe = _(this.gruppert).find({kolonne: this.beregnKolonnne(oppgave)});
                  if (gruppe !== nyGruppe) {
                      _.remove(gruppe.oppgaver, {id: oppgave.id});
                      nyGruppe.oppgaver.push(oppgave);

                  } else
                      gruppe.oppgaver[_(gruppe.oppgaver).findIndex({id: oppgave.id})] = oppgave;
                  //this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Oppgave oppdatert"));
              })
          });
    }

    private lyttTilOppgaveSlettet() {
        this.modelloppdatering.vedSlettetOppgave(
            oppgaveOgMøte => this.finnOppgavensGruppe(oppgaveOgMøte.oppgaveId) != null,
            this.$scope,
            oppgaveOgMøte => {
                const gruppe = this.finnOppgavensGruppe(oppgaveOgMøte.oppgaveId);
                _.remove(gruppe.oppgaver, {id: oppgaveOgMøte.oppgaveId});
                // this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Oppgave slettet"));
            });
    }
}

interface Oppgavegruppe {
    kolonne: OppgaveKolonner;
    sortering: number;
    oppgaver: l.OppgaveModell[];
}

enum OppgaveKolonner {
    planlagte, aktive, utfoerte
}
